import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './lib/useAuth'
import { Dashboard } from './pages/Dashboard'
import { Workers } from './pages/Workers'
import { WorkerDetail } from './pages/WorkerDetail'
import { Hotels } from './pages/Hotels'
import { Codes } from './pages/Codes'
import { Login } from './pages/Login'
import { Sidebar } from './components/Sidebar'
import './App.css'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  
  if (loading) return <div className="loading">Loading...</div>
  if (!user) return <Navigate to="/login" />
  
  return (
    <div className="admin-layout">
      <Sidebar />
      <main className="admin-main">{children}</main>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/workers" element={
            <ProtectedRoute>
              <Workers />
            </ProtectedRoute>
          } />
          <Route path="/workers/:id" element={
            <ProtectedRoute>
              <WorkerDetail />
            </ProtectedRoute>
          } />
          <Route path="/hotels" element={
            <ProtectedRoute>
              <Hotels />
            </ProtectedRoute>
          } />
          <Route path="/codes" element={
            <ProtectedRoute>
              <Codes />
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
